import React, { useState, useEffect, useRef } from "react";
// import FridLogo from "../assets/FridLogo.png";
import no_image from "../assets/no_image.png";
import Compétences from "../assets/Compétences.svg";
import { FiMapPin } from "react-icons/fi";
import messages from "../assets/messages.svg";
import akarIconsCalendar from "../assets/akar-icons_calendar.svg";
import tel from "../assets/tel.svg";
import ReactPaginate from "react-paginate";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import searchIcon from "../assets/search.svg";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
// import mapboxgl from "mapbox-gl";
import Mapbox from "../component/mapbox/Mapbox";
import PageLoaderComp from "../component/pageLoaderComp";
export default function DirectoryOfGreffe() {
  // Initialize map when component mounts
  /* const [map, setMap] = useState(null);
  const [lng, setLng] = useState(-6.27614);
  const [lat, setLat] = useState(31.7917);
  const [zoom, setZoom] = useState(5); */
  const [loadingFullpage, setLoadingFullpage] = useState(false);
  const [paginateData, setPaginateData] = useState({
    "current": 1,
    "total_pages": 0,
    "total_results": 0,
    "size": 100
  });
  const { city, postalCode } = useParams();
  const [data, setData] = useState([]);

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(100);
  const [geoJson, setGeoJson] = useState({
    "type": "FeatureCollection",
    "features": []
  });

  /* {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": []
      }
    } */

  // MAPBOX START
  /* mapboxgl.accessToken =
  "pk.eyJ1Ijoia2lmd2F0aW1tbyIsImEiOiJjbHBhd3Nzb3EwY3pvMmtsczY5azJmc3ltIn0.iVAboNpdF5y0BSjjeHEGMg";

   */
  useEffect(() => {
   /*  const map = new mapboxgl.Map({
      container: 'map',
      style: "mapbox://styles/kifwatimmo/clger8d0m008o01n2asql0cx9",
      center: [lng, lat],
      zoom: zoom,
    });
    // ==============| On load map |================
    map.on("load", () => {
      // Add a custom source for the country boundaries
      setMap(map);      
    });
    return () => map.remove(); */
 
  
  },[])
  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    // setPageCount(Math.ceil(data.length / itemPerPage));
    setPageCount(Math.ceil(paginateData.total_results / itemPerPage))
    /* const endOffset = itemOffset + itemPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemPerPage)); */
  }, [postalCode, itemOffset, data,paginateData]);
  // Use Effect
  useEffect(() => {
    setLoadingFullpage(true);
    // let URL = process.env.REACT_APP_API_URL + "api/admin/get_directive_greffe";    
    let URL = process.env.REACT_APP_API_URL + "api/admin/search_directive_greffe";    
    let data = { search: postalCode,size:paginateData.size,currentPage:paginateData.current };

    // let URL = `https://enterprise-search.kifwat.net/api/as/v1/engines/directory-greffe/search`;
    
    // let data = JSON.stringify({
    //   "query": postalCode,
    //   /* "group": {
    //     "field": "code_postal"
    //   } */
    // });
    let config = {
      method: "post",
      url: URL,
      data: data,
      headers: { 
        // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
        // 'Accept': '*/*', 
        // "Cache-Control":"no-cache",
        'Content-Type': 'application/json', 
      },
    };

    axios
      .request(config)
      .then((response) => {
        setLoadingFullpage(false);
        // console.log("response.data",response.data.data.results);
        if(response.data && response.data.data && response.data.data.results.length>0){
          let jsonData = [];
          response.data.data.results.map((val,key)=>{
            let coordinatesArr = (val.coordonneesgps.raw).split(",");
            jsonData.push({
              "type": "Feature",
              "geometry": {
                "type": "Point",
                "coordinates": [parseFloat(coordinatesArr[0]),parseFloat(coordinatesArr[1])]
              }
            } )
          })
          // console.log("jsonData",jsonData)
          setGeoJson({
            "type": "FeatureCollection",
            "features": jsonData
          });
        }
        setData(response.data.data.results);
        setPaginateData(response.data.data.meta.page);
      })
      .catch((error) => {
        setLoadingFullpage(false);
        console.log(error);
      });

  }, [postalCode]);
  // ======================================getSearchResult
const getSearchResult=(currentPage)=>{
  setLoadingFullpage(true);
   // let URL = process.env.REACT_APP_API_URL + "api/admin/get_directive_greffe";    
   let URL = process.env.REACT_APP_API_URL + "api/admin/search_directive_greffe";    
   let data = { search: postalCode,size:paginateData.size,currentPage:paginateData.current };

   // let URL = `https://enterprise-search.kifwat.net/api/as/v1/engines/directory-greffe/search`;
   
   // let data = JSON.stringify({
   //   "query": postalCode,
   //   /* "group": {
   //     "field": "code_postal"
   //   } */
   // });
   let config = {
     method: "post",
     url: URL,
     data: data,
     headers: { 
       // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
       // 'Accept': '*/*', 
       // "Cache-Control":"no-cache",
       'Content-Type': 'application/json', 
     },
   };

   axios
     .request(config)
     .then((response) => {
      setLoadingFullpage(false);
       // console.log("response.data",response.data.data.results);
       if(response.data && response.data.data && response.data.data.results.length>0){
         let jsonData = [];
         response.data.data.results.map((val,key)=>{
           let coordinatesArr = (val.coordonneesgps.raw).split(",");
           jsonData.push({
             "type": "Feature",
             "geometry": {
               "type": "Point",
               "coordinates": [parseFloat(coordinatesArr[0]),parseFloat(coordinatesArr[1])]
             }
           } )
         })
         // console.log("jsonData",jsonData)
         setGeoJson({
           "type": "FeatureCollection",
           "features": jsonData
         });
       }
       setData(response.data.data.results);
       setPaginateData(response.data.data.meta.page);
     })
     .catch((error) => {
      setLoadingFullpage(false);
       console.log(error);
     });
}
  // ====================================
  const [deCriteres, setDeCriteres] = useState(false);
  const onClick = () => {
    setDeCriteres(!deCriteres);
  };
  // ================================================
  /* =====================|Get Default Values|================== */
  const searchRef = useRef(null);
  const [search, setSearch] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  // Search Input data
  function getInputSearchData(input) {
    setSearchKey(input);
    // console.log("input",input)
    if (input) {
      // let data = JSON.stringify({
      //   "query": input,
      //   "group": {
      //     "field": "code_postal"
      //   }
      // });
      // let config = {
      //   method: 'post',
      //   maxBodyLength: Infinity,
      //   url: 'https://enterprise-search.kifwat.net/api/as/v1/engines/directory-greffe/search',
      //   headers: { 
      //     'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
      //     'Accept': '*/*', 
      //     "Cache-Control":"no-cache",
      //     'Content-Type': 'application/json', 
      //   },
      //   data : data
      // };
      // axios.request(config)
      // .then((response) => {

      //   if((response.data.results).length>0){
      //     let resultList  = response.data.results.filter((val,i)=>val.villefranche_cedex.raw && val.code_postal.raw)
      //     setSearch(resultList);
      //     setCheckList(true);
      //   }else{
      //     setSearch(response.data.results);
      //   }
      // })
      // .catch((error) => {
      //   // Handle any errors that occurred during the request
      //   console.error(error);
      //   setCheckList(false);
      // });
      
      axios
        .post(
          process.env.REACT_APP_API_URL +
            `api/admin/search_directive_greffe`,
          { search: input  ,size:10,currentPage:1}
        )
        .then((response) => {
          // Handle a successful response
          if((response.data.data.results).length>0){
            let resultList  = response.data.data.results.filter((val,i)=>val.villefranche_cedex.raw && val.code_postal.raw)
            setSearch(resultList);
            setCheckList(true);
          }else{
            setSearch(response.data.data.results);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the request
          console.error(error);
          setCheckList(false);
        });
    } else {
      setCheckList(false);
    }
  }

  
  // ========================================
  const [checkList, setCheckList] = useState(false);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [search, checkList]);

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setCheckList(false);
    }
  };
  // ======================|pagination|=========================
  function Items({ currentItems }) {
    return (
      <div className="items mb-2">
        {currentItems &&
          currentItems.map((list) => {
            let cleanedStr = "";
            let array = [];
            let url = no_image;
            if(list.logo && list.logo.raw){
              cleanedStr = list.logo.raw.replace(/^\[('|")?|('|")?\]$/g, "");
              array = cleanedStr.split(",");
              url = array[0].trim();
            }
           
            return (
              <div className="btnShadow lg:max-w-[723px] w-full h-auto py-8 px-4 bg-white rounded-[21px] mt-8">
                <Link
                  to={"/fiche-greffe/" + list.id.raw}
                  className="flex sm:flex-row flex-col items-center gap-4"
                >
                  <img src={url} alt={url} />
                  <div className="flex items-start sm:flex-row flex-col justify-between w-full">
                    <div>
                      <h4 className="font-bold text-lg 3xl:text-xl text-primary">
                        {list.name.raw}
                      </h4>
                      <h6 className="text-base font-semibold text-primary">
                        Cabinet comptable
                      </h6>
                      <p className="text-base font-light text-primary">
                        Expert-comptable - Commissaire aux comptes
                      </p>
                    </div>

                    <div className="flex whitespace-nowrap items-center gap-1 mt-4 sm:my-0">
                      <FiMapPin />
                      <p>
                        {list.villefranche_cedex.raw} ({list.code_postal.raw})
                      </p>
                    </div>
                  </div>
                </Link>

                <hr className="my-6 border-black-light opacity-50" />

                <div>
                  <div className="flex gap-2 mt-4">
                    <img src={Compétences} alt="" />
                    <p className="text-base font-normal text-primary">
                      Compétences
                    </p>
                  </div>
                  <div className="mt-4 flex gap-2 items-center flex-wrap  ">
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Gestion de la paie{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Commissaire à la fusion{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Commissaire à la fusion{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      + 5
                    </div>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="flex gap-2 mt-4">
                    <img src={Compétences} alt="" />
                    <p className="text-base font-normal text-primary">
                      Secteurs
                    </p>
                  </div>
                  <div className="mt-4 flex gap-2 items-center flex-wrap">
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      TPE -PME -ETI{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Profession libérale{" "}
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      Commerce
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      E-Commerce
                    </div>
                    <div
                      className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                      style={{ background: "rgba(222, 227, 226, 0.5)" }}
                    >
                      + 3
                    </div>
                  </div>
                </div>

                <div className="flex justify-between items-center mt-8 gap-1 sm:gap-4">
                  <button className="w-full max-w-[252px] h-full min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white  text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary">
                    <img
                      src={messages}
                      alt="messages"
                      className="w-4 h-4 sm:w-auto sm:h-auto"
                    />
                    Message
                  </button>
                  <button className="w-full max-w-[252px] h-full  min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary">
                    <img
                      src={tel}
                      alt="messages"
                      className="w-4 h-4 sm:w-auto sm:h-auto rotate_telephone"
                    />
                    Contacter
                  </button>
                  {/* <button className="w-full max-w-[252px] h-full  min-h-[30px] sm:min-h-[50px] flex items-center justify-center gap-1 sm:gap-3 bg-primary text-white text-xs sm:text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary">
                    <img
                      src={akarIconsCalendar}
                      alt="akarIconsCalendar"
                      className="w-4 h-4 sm:w-auto sm:h-auto"
                    />
                    Prendre RDV
                  </button> */}
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * 4) % data.length;
    setItemOffset(newOffset);
    setPaginateData(paginateData => ({ ...paginateData, ["current"]: event.selected+1 }));
    getSearchResult(event.selected+1 );
    /* setPaginateData({
      "current": event.selected+1,
      "total_pages": 0,
      "total_results": 0,
      "size": 10
    }) */
  };

  
  return (
    <>
     
      <div className='max-w-[1277px] m-auto my-8 md:mt-5 flex justify-center items-center flex-col gap-4'>
      <div
          style={{
            position: "relative",
          }}
        >
          <form
            id="searchForm"
            className="bg-white border-0 max-w-[727px] sm:mx-auto my-6 px-5 py-3 sm:py-6 input-box-shadow rounded flex justify-between w-full"
            style={{ boxShadow: "0px 2px 12px rgba(83, 83, 83, 0.25)" ,zIndex:"9" }}
          >
            <input
              type="text"
              onInput={(e) => getInputSearchData(e.target.value)}
              defaultValue={postalCode}
              className=" w-full outline-none text-[#797979] text-base font-light"
              placeholder="Nom de la ville ou du département"
            />
            <button>
              <img src={searchIcon} alt="searchIcon" />
            </button>
          </form>
          <div
            style={{
              display: checkList ? "block" : "none",
              left: "0",
              right: "0",
              top: "80px",zIndex:"9"
            }}
            className="searchListBox max-w-[727px] sm:mx-auto"
            ref={searchRef}
          >
            <ul>
              {search.length === 0 ? (
                <div
                  className="containertype"
                  style={{ textAlign: "left",padding: "9px 19px"}}
                >
                  <span>No search result found!</span>
                  {/* <div className="dottype"></div>
                  <div className="dottype"></div>
                  <div className="dottype"></div> */}
                </div>
              ) : (
                ""
              )}
              {search.map((list) => {
                return (
                  <li>
                    <Link
                      onClick={(e)=>{
                        setCheckList(false)
                        setPaginateData({
                          "current": 1,
                          "total_pages": 0,
                          "total_results": 0,
                          "size": 100
                        })
                      }}
                      className="ctmref"
                      to={`/directory-search-result/greffe/${searchKey}/${paginateData.size}/${paginateData.current}`}
                    >
                      {list.villefranche_cedex.raw} ({list.code_postal.raw})

                    </Link>
                  </li>
                );
              })}
              <li className={search.length>0?"":"hidden"} style={{"fontWeight":"700"}}>
                <Link
                  onClick={(e)=>{
                    setCheckList(false)
                    setPaginateData({
                      "current": 1,
                      "total_pages": 0,
                      "total_results": 0,
                      "size": 100
                    })
                  }}
                  className="ctmref"
                  to={`/directory-search-result/greffe/${searchKey}/${paginateData.size}/${paginateData.current}`}
                >
                  {"Voir tous les résultats de la recherche"}
                </Link>
              </li>
            </ul>
          </div>
        </div>
       {/*  <form className"bg-white border-0 max-w-[727px] sm:mx-auto my-6 px-5 py-3 sm:py-6 input-box-shadow rounded-full flex justify-between w-full" style={{ boxShadow: '0px 2px 12px rgba(83, 83, 83, 0.25)' }}>
          <input type="text" className=" w-full outline-none text-[#797979] text-base font-light" placeholder="Nom de la ville ou du département" />
          <button>
            <img src={searchIcon} alt="searchIcon" />
          </button>
        </form> */}
      </div>
      <div className='w-full bg-mainBg'>
        <div className='grid grid-cols-12'>
          <div className='2lg:col-span-5 lg:col-span-6 col-span-12 px-4 py-10'>
            <h5 className='text-lg font-normal text-primary'><span className='font-semibold'>({data.length})</span>  Résultat pour Greffe de France <span className='font-semibold'>{city}</span></h5>
            {data.map((list) => {
              return (
              <>
                <div className='btnShadow lg:max-w-[723px] w-full h-auto py-8 px-4 bg-white rounded-[21px] mt-8'>
                  <div className='flex items-center gap-2'>
                    <svg width="45" height="46" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M25 13.7852C25.7367 13.7852 26.4432 13.4947 26.9642 12.9777C27.4851 12.4607 27.7778 11.7596 27.7778 11.0284C27.7778 10.2973 27.4851 9.59608 26.9642 9.07909C26.4432 8.5621 25.7367 8.27166 25 8.27166C24.2633 8.27166 23.5567 8.5621 23.0358 9.07909C22.5149 9.59608 22.2222 10.2973 22.2222 11.0284C22.2222 11.7596 22.5149 12.4607 23.0358 12.9777C23.5567 13.4947 24.2633 13.7852 25 13.7852V13.7852ZM26.8694 0.616145C26.3295 0.216123 25.6738 0 25 0C24.3262 0 23.6705 0.216123 23.1306 0.616145L0.986111 17.0216C-0.888889 18.4096 0.101389 21.3662 2.43889 21.3662H4.16667V37.9137C2.91984 38.5006 1.86644 39.4267 1.12887 40.5842C0.391298 41.7417 -0.000153329 43.0832 4.50527e-08 44.4527V49.277C4.50527e-08 50.2281 0.777778 51 1.73611 51H48.2639C49.2222 51 50 50.2281 50 49.277V44.4527C50.0002 43.0832 49.6087 41.7417 48.8711 40.5842C48.1336 39.4267 47.0802 38.5006 45.8333 37.9137V21.3649H47.5611C49.9 21.3649 50.8889 18.4082 49.0153 17.0202L26.8694 0.616145V0.616145ZM42.3611 37.2162H36.1111V21.3649H42.3611V37.2162ZM32.6389 37.2162H26.7361V21.3649H32.6389V37.2162ZM23.2639 37.2162H17.3611V21.3649H23.2639V37.2162ZM13.8889 37.2162H7.63889V21.3649H13.8889V37.2162ZM5.575 17.9203L25 3.53004L44.4236 17.9203H5.575ZM3.47222 44.4541C3.47222 43.4488 3.87463 42.4846 4.59091 41.7738C5.3072 41.0629 6.27869 40.6635 7.29167 40.6635H42.7083C43.7213 40.6635 44.6928 41.0629 45.4091 41.7738C46.1254 42.4846 46.5278 43.4488 46.5278 44.4541V47.5554H3.47222V44.4541Z" fill="#27295B" />
                    </svg>
                    <h4 className='font-bold text-lg 3xl:text-xl text-primary'>Greffe du tribunal de commerce de {list.villefranche_cedex.raw}  – {(list.code_postal.raw).slice(0, 2)} ({list.nomdugreffe.raw})</h4>
                  </div>

                  <hr className='my-6 border-black-light opacity-50' />

                  <div className='flex items-start gap-4'>
                    <svg width="26" height="34" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12.8164C1 6.29985 6.33894 1 12.9461 1C19.5532 1 24.8921 6.29985 24.8921 12.8164C24.8921 13.8048 24.7548 14.9651 24.4752 16.0598C24.1925 17.1661 23.7834 18.1315 23.2857 18.7844L24.081 19.3906L23.2857 18.7844L12.9461 32.3503L2.60643 18.7844C1.45498 17.2737 1 15.0871 1 12.8164ZM19.3941 12.8164C19.3941 9.27638 16.4973 6.42296 12.9461 6.42296C9.39488 6.42296 6.49809 9.27638 6.49809 12.8164C6.49809 16.3565 9.39488 19.2098 12.9461 19.2098C16.4973 19.2098 19.3941 16.3564 19.3941 12.8164Z" stroke="#1CBE93" strokeWidth="2" />
                    </svg>
                    <div>
                      <h6 className='text-[15] font-semibold text-primary'>Adresse du Tribunal de commerce de {list.villefranche_cedex.raw}  – {list.code_postal.raw} </h6>
                      <p className='text-[15] text-primary font-normal mt-1'>Greffe du tribunal de commerce de {list.villefranche_cedex.raw}</p>
                      <p className='text-[15] text-primary font-normal'>{list.Numerodevoie}  {list.Typedevoie} {list.Voie}</p>
                      <p className='text-[15] text-primary font-normal'> {list.code_postal.raw} {list.villefranche_cedex.raw}</p>
                    </div>
                  </div>
                  {/* <div className='flex items-start gap-4 mt-4'>
                    <svg width="30" height="37" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.7085 8.78673L21.7088 8.78699C22.1529 9.23726 22.404 9.8497 22.4046 10.4901V27.125C22.4046 28.0225 22.0533 28.8818 21.4303 29.5141C20.8075 30.1463 19.9645 30.5 19.0871 30.5H3.81743C2.94003 30.5 2.09702 30.1463 1.47429 29.5141C0.851304 28.8818 0.5 28.0225 0.5 27.125V3.875C0.5 2.9775 0.851304 2.11824 1.47429 1.48586C2.09702 0.853732 2.94003 0.5 3.81743 0.5H12.5707C12.5707 0.5 12.5708 0.5 12.5708 0.5C13.1945 0.500164 13.7942 0.75155 14.2378 1.20141C14.2378 1.20147 14.2379 1.20152 14.2379 1.20157L21.7085 8.78673ZM11.9523 1.9375V1.4375H11.4523H3.81743C3.17616 1.4375 2.5627 1.69615 2.11157 2.15408C1.6607 2.61176 1.40871 3.23093 1.40871 3.875V27.125C1.40871 27.7691 1.6607 28.3882 2.11157 28.8459L2.46776 28.495L2.11157 28.8459C2.5627 29.3038 3.17616 29.5625 3.81743 29.5625H19.0871C19.7284 29.5625 20.3419 29.3038 20.793 28.8459C21.2439 28.3882 21.4959 27.7691 21.4959 27.125V11.625V11.125H20.9959H14.3154C13.6911 11.125 13.0908 10.8733 12.647 10.4229C12.203 9.97218 11.9523 9.35932 11.9523 8.71875V1.9375ZM20.6007 10.1875H21.7952L20.9569 9.3366L13.7172 1.98767L12.861 1.11856V2.33856V8.71875C12.861 9.10589 13.0124 9.47866 13.2843 9.75466C13.5565 10.0309 13.9272 10.1875 14.3154 10.1875H20.6007ZM4.31743 16.4688C4.31743 16.342 4.36709 16.222 4.45314 16.1346C4.53895 16.0475 4.65372 16 4.77178 16C4.88985 16 5.00462 16.0475 5.09043 16.1346C5.17648 16.222 5.22614 16.342 5.22614 16.4688C5.22614 16.5955 5.17648 16.7155 5.09043 16.8029C5.00462 16.89 4.88985 16.9375 4.77178 16.9375C4.65372 16.9375 4.53895 16.89 4.45314 16.8029C4.36709 16.7155 4.31743 16.5955 4.31743 16.4688ZM4.45314 20.0096C4.53895 19.9225 4.65372 19.875 4.77178 19.875C4.88985 19.875 5.00462 19.9225 5.09043 20.0096C5.17648 20.097 5.22614 20.217 5.22614 20.3438C5.22614 20.4705 5.17648 20.5905 5.09043 20.6779C5.00462 20.765 4.88985 20.8125 4.77178 20.8125C4.65372 20.8125 4.53895 20.765 4.45314 20.6779C4.36709 20.5905 4.31743 20.4705 4.31743 20.3438C4.31743 20.217 4.36709 20.097 4.45314 20.0096ZM4.31743 24.2188C4.31743 24.092 4.36709 23.972 4.45314 23.8846C4.53895 23.7975 4.65372 23.75 4.77178 23.75C4.88985 23.75 5.00462 23.7975 5.09043 23.8846C5.17648 23.972 5.22614 24.092 5.22614 24.2188C5.22614 24.3455 5.17648 24.4655 5.09043 24.5529C5.00462 24.64 4.88985 24.6875 4.77178 24.6875C4.65372 24.6875 4.53895 24.64 4.45314 24.5529C4.36709 24.4655 4.31743 24.3455 4.31743 24.2188ZM8.27057 16.1346C8.35637 16.0475 8.47114 16 8.58921 16H18.1328C18.2508 16 18.3656 16.0475 18.4514 16.1346C18.5375 16.222 18.5871 16.342 18.5871 16.4688C18.5871 16.5955 18.5375 16.7155 18.4514 16.8029C18.3656 16.89 18.2508 16.9375 18.1328 16.9375H8.58921C8.47114 16.9375 8.35637 16.89 8.27057 16.8029C8.18451 16.7155 8.13486 16.5955 8.13486 16.4688C8.13486 16.342 8.18451 16.222 8.27057 16.1346ZM8.13486 20.3438C8.13486 20.217 8.18451 20.097 8.27057 20.0096C8.35637 19.9225 8.47114 19.875 8.58921 19.875H18.1328C18.2508 19.875 18.3656 19.9225 18.4514 20.0096C18.5375 20.097 18.5871 20.217 18.5871 20.3438C18.5871 20.4705 18.5375 20.5905 18.4514 20.6779C18.3656 20.765 18.2508 20.8125 18.1328 20.8125H8.58921C8.47114 20.8125 8.35637 20.765 8.27057 20.6779C8.18451 20.5905 8.13486 20.4705 8.13486 20.3438ZM8.27057 23.8846C8.35637 23.7975 8.47114 23.75 8.58921 23.75H18.1328C18.2508 23.75 18.3656 23.7975 18.4514 23.8846C18.5375 23.972 18.5871 24.092 18.5871 24.2188C18.5871 24.3455 18.5375 24.4655 18.4514 24.5529C18.3656 24.64 18.2508 24.6875 18.1328 24.6875H8.58921C8.47114 24.6875 8.35637 24.64 8.27057 24.5529C8.18451 24.4655 8.13486 24.3455 8.13486 24.2188C8.13486 24.092 8.18451 23.972 8.27057 23.8846Z" fill="#27295B" stroke="#1CBE93" />
                    </svg>

                    <div>
                      <h6 className='text-[15] font-semibold text-primary'>Liste des journaux habilités pour la publication d'annonces legal dans le département de 01 (Ain)</h6>
                      <p className='text-[15] text-primary font-normal mt-1'>L'Ain Agricole</p>
                      <p className='text-[15] text-primary font-normal'>La Voix de l’Ain</p>
                      <p className='text-[15] text-primary font-normal'>La Tribune Républicaine</p>
                      <p className='text-[15] text-primary font-normal'>Le Progrès (Edition de l’Ain)</p>
                    </div>
                  </div> */}

                </div>
              </>
              )})
            }

          </div>
          <div className='2lg:col-span-7 lg:col-span-6 col-span-12'>
            {/* <img src={mapDemo} alt="mapDemo" className='h-screen w-full' /> */}
            <Mapbox geoJson={geoJson}/>
            {/* <iframe title='france' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5666151.454104781!2d-3.2305647495523675!3d46.09744499642553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd54a02933785731%3A0x6bfd3f96c747d9f7!2sFrance!5e0!3m2!1sen!2sin!4v1685359635891!5m2!1sen!2sin" style={{ width: '100%', height: '100%', minHeight: '785px' }} loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
          </div>
        </div >
      </div >
      <Footer />
    </>
  );
}
